import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import {
    SHIKSHA_KPI_STRIP_CONTENT,
    SHIKSHA_KPI_ITEMS,
} from '../constants/shiksha-dashboard.constants'
import type { IShikshaKpiItem } from '@features/home/models/shiksha-dashboard.model'
import { ShikshaKpiCardComponent } from '../shiksha-kpi-card/shiksha-kpi-card.component'

@Component({
    selector: 'app-shiksha-kpi-strip',
    templateUrl: './shiksha-kpi-strip.component.html',
    styleUrl: './shiksha-kpi-strip.component.scss',
    imports: [ShikshaKpiCardComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShikshaKpiStripComponent {
    readonly content = SHIKSHA_KPI_STRIP_CONTENT

    readonly kpiItems = input<readonly IShikshaKpiItem[]>(SHIKSHA_KPI_ITEMS)
}
